import {Component} from '@angular/core';


import {TranslateModule} from '@ngx-translate/core';
import {ActiveModal} from "../../modal";

@Component({
    selector: 'app-update-confirmation-modal',
    imports: [TranslateModule],
    templateUrl: './update-confirmation-modal.component.html',
    styleUrls: ['./update-confirmation-modal.component.scss']
})
export class UpdateConfirmationModalComponent {
    constructor(public activeModal: ActiveModal) {
    }

    onConfirm(): void {
        this.activeModal.close('confirm');
    }

    onCancel(): void {
        this.activeModal.dismiss('cancel');
    }
}
